import _objectWithoutProperties from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children"];
import { createElementObject, createPathComponent, extendContext } from '@react-leaflet/core';
import { FeatureGroup as LeafletFeatureGroup } from 'leaflet';
export var FeatureGroup = createPathComponent(function createFeatureGroup(_ref, ctx) {
  var _c = _ref.children,
    options = _objectWithoutProperties(_ref, _excluded);
  var group = new LeafletFeatureGroup([], options);
  return createElementObject(group, extendContext(ctx, {
    layerContainer: group,
    overlayContainer: group
  }));
});